exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".save-cancel-group-content {\n  background-color: #fff;\n  padding-top: 0; }\n  .save-cancel-group-content .save-cancel-group {\n    display: flex;\n    justify-content: flex-end; }\n    .save-cancel-group-content .save-cancel-group button {\n      margin-left: 1rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/manage/common/saveAndCancelBottomButtons/saveAndCancelBottomButtons.scss
// module id = 1368
// module chunks = 0